const header = document.querySelector('.js-header-fixed');


function onScroll() {
    if (header) {
        if (window.scrollY > 0 || window.pageYOffset > 0) {
            header.classList.add('is-fixed');
        } else {
            header.classList.remove('is-fixed');
        }
        requestAnimationFrame(onScroll);
    }
}

onScroll();



// WEBPACK FOOTER //
// ./resources/assets/js/modules/fixedHeader.js